import React, { FC } from 'react';

import { Box } from '@chakra-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';

import { TwoFactorAuthContent } from './TwoFactorAuthContent';
import { EColor } from '../../Theme';
import { defaultQueryClient } from '../../utilities';
import { VerificationStepperProvider } from '../context/VerificationStepperContext';

export interface ITwoFactorAuthProps {
  onSuccess: (...args: unknown[]) => void;
  monolithBaseUrl: string;
}

export const TwoFactorAuth: FC<ITwoFactorAuthProps> = ({
  onSuccess,
  monolithBaseUrl,
}) => (
  <QueryClientProvider client={defaultQueryClient}>
    <VerificationStepperProvider>
      <Box backgroundColor={EColor.White} paddingX="16px">
        <Box
          margin="0 auto"
          maxW="448px"
          paddingBottom="112px"
          paddingTop={{ base: '56px', md: '65px' }}
        >
          <TwoFactorAuthContent
            monolithBaseUrl={monolithBaseUrl}
            onSuccess={onSuccess}
          />
        </Box>
      </Box>
    </VerificationStepperProvider>
  </QueryClientProvider>
);
